'use client';

import { useSyncExternalStore } from 'react';

const DESKTOP_JOB_FILTERS_QUERY = '(min-width: 640px)';

function subscribeToDesktopFilters(onChange: () => void) {
  const mediaQuery = window.matchMedia(DESKTOP_JOB_FILTERS_QUERY);

  mediaQuery.addEventListener('change', onChange);

  return () => mediaQuery.removeEventListener('change', onChange);
}

function getDesktopFiltersSnapshot() {
  return window.matchMedia(DESKTOP_JOB_FILTERS_QUERY).matches;
}

export function useDesktopJobFilters(initialDesktopViewport = false) {
  return useSyncExternalStore(
    subscribeToDesktopFilters,
    getDesktopFiltersSnapshot,
    () => initialDesktopViewport
  );
}
